import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Search from '../../../Search/Header/Header.js';
import { toggleModal } from '../../../Modal/modalActions';
import { refreshLeadToLive } from '../../../LeadToLive/leadToLiveActions';
import RefreshIcon from '../../../../images/refresh.svg';

export class ToolbarItems extends Component {
    static propTypes = {
        isSearchOpen: PropTypes.bool,
        accountType: PropTypes.string,
        currentPath: PropTypes.string,
        onOpenPrevetModal: PropTypes.func,
        onRefreshLeadToLive: PropTypes.func
    };

    render() {
        const isReseller = this.props.accountType === 'RESELLER';
        const isPathToLivePage = this.props.currentPath === '/pathToLive';

        return (
            <div className="toolbar-items">
                {!isReseller && (
                    <div className="toolbar-item toolbar-item-search">
                        <Search isSearchOpen={this.props.isSearchOpen} />
                    </div>
                )}
                {/* update this condition to add refresh button to other pages */}
                {isPathToLivePage && (
                    <div className="toolbar-item toolbar-item-refresh">
                        <img
                            src={RefreshIcon}
                            alt="Refresh"
                            className="refresh-icon"
                            onClick={this.props.onRefreshLeadToLive}
                            title="Refresh data"
                        />
                    </div>
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onOpenPrevetModal: () => dispatch(toggleModal('prevetForm', {})),
        onRefreshLeadToLive: () => dispatch(refreshLeadToLive())
    };
}

export default connect(null, mapDispatchToProps)(ToolbarItems);
